import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-chevron-left",
  "use": "n-icon-chevron-left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"n-icon-chevron-left\">\n    <path d=\"M8.30171 10L11.7682 14.3598C12.1218 14.7841 12.0645 15.4147 11.6402 15.7682C11.2159 16.1218 10.5853 16.0645 10.2318 15.6402L6.23178 10.6402C5.92275 10.2694 5.92275 9.73069 6.23178 9.35984L10.2318 4.35984C10.5853 3.93556 11.2159 3.87824 11.6402 4.2318C12.0645 4.58537 12.1218 5.21593 11.7682 5.64021L8.30171 10Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol